<template>
    <default-field :errors="errors" :title="title" :wrap="wrap">
        <template v-slot:field="slotProps">
            <input
                :type="$attrs.type ? $attrs.type : 'text'"
                :class="[slotProps.hasErrors ? invalidClass : '', className]"
                v-bind="$attrs"
                v-on:input="$emit('input', $event.target.value)"
            />
        </template>
    </default-field>
</template>

<script>
import DefaultField from "./DefaultField";

export default {
    components: {
        DefaultField
    },

    inheritAttrs: false,

    props: {
        className: {
            type: String,
            default:
                "shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:border-gray-600"
        },
        invalidClass: {
            type: String,
            default: "is-invalid"
        },
        errors: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: null
        },
        wrap: {
            type: Boolean,
            default: true
        }
    }
};
</script>